/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Join_Tier_To_UnlockInputs */

const en_join_tier_to_unlock = /** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join Tier ${i?.tier}+ to Unlock`)
};

const id_join_tier_to_unlock = /** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gabung Paket ${i?.tier}+ untuk Membuka`)
};

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const es_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const fr_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const de_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const ja_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const zh_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const ar_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const it_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const ru_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const pt_join_tier_to_unlock = en_join_tier_to_unlock;

/** @type {(inputs: Join_Tier_To_UnlockInputs) => LocalizedString} */
const ko_join_tier_to_unlock = en_join_tier_to_unlock;

/**
* | output |
* | --- |
* | "Join Tier {tier}+ to Unlock" |
*
* @param {Join_Tier_To_UnlockInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_tier_to_unlock = /** @type {((inputs: Join_Tier_To_UnlockInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_Tier_To_UnlockInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_tier_to_unlock(inputs)
	if (locale === "es") return es_join_tier_to_unlock(inputs)
	if (locale === "fr") return fr_join_tier_to_unlock(inputs)
	if (locale === "de") return de_join_tier_to_unlock(inputs)
	if (locale === "ja") return ja_join_tier_to_unlock(inputs)
	if (locale === "zh") return zh_join_tier_to_unlock(inputs)
	if (locale === "ar") return ar_join_tier_to_unlock(inputs)
	if (locale === "id") return id_join_tier_to_unlock(inputs)
	if (locale === "it") return it_join_tier_to_unlock(inputs)
	if (locale === "ru") return ru_join_tier_to_unlock(inputs)
	if (locale === "pt") return pt_join_tier_to_unlock(inputs)
	return ko_join_tier_to_unlock(inputs)
});